module.exports = __webpack_public_path__ + "static/media/avatar.fa8c6cb4.png";